import React from 'react';
import PropTypes from 'prop-types';

import { Label, SimpleTimer } from '@atlas/ui';

import { bonusStatuses } from 'common/constants';
import { RenderBonusStatus } from 'components/ClientProfile/Bonuses/DepositBonuses/BunusesItemExpand/BonusStatus';

const { ACTIVATED, CANCELED, COMPLETED, DISABLED, EXPIRED, IN_PROGRESS, LOSE, PENDING, VOID, WIN } =
  bonusStatuses;

const BonusStatus = ({ bonus }) => {
  const { activationTime, freeBet: { timeToUse } = {}, status } = bonus;

  switch (status) {
    case WIN:
      return <RenderBonusStatus status="win" />;
    case VOID:
      return <RenderBonusStatus status="void" />;
    case PENDING:
    case CANCELED:
    case COMPLETED:
    case DISABLED:
    case EXPIRED:
    case IN_PROGRESS:
    case LOSE:
      return <RenderBonusStatus status={status} />;

    case ACTIVATED:
      return (
        <div className="profile-bonus-activated">
          <Label
            className="profile-bonus-activated__text"
            message="Before the bonus is deactivated there are"
          />

          <SimpleTimer time={timeToUse + activationTime} />
        </div>
      );

    default:
      return null;
  }
};

BonusStatus.propTypes = { bonus: PropTypes.object.isRequired };

export default BonusStatus;
